import moment from 'moment';

export function useDate() {
  function dateToClient(strDate) {
    if (moment(strDate).isValid()) {
      return moment(strDate).format('DD/MM/YYYY');
    }
    return strDate;
  }

  function datetimeToClient(strDate) {
    if (moment(strDate).isValid()) {
      return moment(strDate).format('DD/MM/YYYY HH:mm');
    }
    return strDate;
  }

  /** Formata ISO UTC para exibição sem converter para fuso local (backend já envia no timezone correto). */
  function datetimeUtcToClient(strDate) {
    if (moment.utc(strDate).isValid()) {
      return moment.utc(strDate).format('DD/MM/YYYY HH:mm');
    }
    return strDate;
  }

  function dateToDatabase(strDate) {
    if (moment(strDate, 'DD/MM/YYYY').isValid()) {
      return moment(strDate).format('YYYY-MM-DD HH:mm:ss');
    }
    return strDate;
  }

  function returnDays(date) {
    let data1 = new Date();
    let data2 = new Date(date);
    let result = data2.getTime() - data1.getTime();
    let days = Math.ceil(result / (1000 * 60 * 60 * 24));

    if (Object.is(days, -0)) {
      days = 0;
    }
    return days;
  }

  /**
   * Retorna o timezone IANA do navegador do usuário.
   * Ex: "America/Sao_Paulo"
   */
  function getUserTimezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch {
      return 'UTC';
    }
  }

  /**
   * Converte valor do input datetime-local para scheduledAt em ISO 8601 com offset.
   * O valor do input é tratado como horário local do usuário.
   *
   * @param {string} datetimeLocalValue - Valor do input (ex: "2026-03-07T14:46" ou "2026-03-07 14:46:00")
   * @returns {{ scheduledAt: string, timezone: string } | null}
   */
  function buildScheduledPayload(datetimeLocalValue) {
    if (!datetimeLocalValue || typeof datetimeLocalValue !== 'string') return null;
    const m = moment(datetimeLocalValue);
    if (!m.isValid()) return null;

    const timezone = getUserTimezone();
    const date = new Date(datetimeLocalValue.replace(/\s+/, 'T'));
    const offsetMin = -date.getTimezoneOffset();
    const sign = offsetMin >= 0 ? '+' : '-';
    const hours = Math.floor(Math.abs(offsetMin) / 60);
    const mins = Math.abs(offsetMin) % 60;
    const offsetStr = sign + String(hours).padStart(2, '0') + ':' + String(mins).padStart(2, '0');
    const scheduledAt = m.format('YYYY-MM-DD') + 'T' + m.format('HH:mm:ss') + offsetStr;

    return { scheduledAt, timezone };
  }

  return {
    dateToClient,
    datetimeToClient,
    datetimeUtcToClient,
    dateToDatabase,
    returnDays,
    getUserTimezone,
    buildScheduledPayload,
  };
}
